export const METHOD_NOT_AVAILABLE_ON_SERVER = 'Not ready on server!';
